import { render, staticRenderFns } from "./AddLibraryProductModal.vue?vue&type=template&id=66cd6ce9"
import script from "./AddLibraryProductModal.vue?vue&type=script&lang=js"
export * from "./AddLibraryProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports